export const normalizeRedirectPath = (redirectPath: string) =>
  `/${redirectPath.replace(/^[\\/]+/, '')}`;
